module["exports"] = [
  "####",
  "###",
  "##"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_AU/address/building_number.js
 ** module id = 379
 ** module chunks = 0
 **/